import React from "react";
import "./Loading.css";

const Loading = (props) => {
  if (!props.show) return null;
  return (
    <div className="Loading" />
  )
}

Loading.defaultProps = {
  show: true
}

export default Loading;